module.exports = __webpack_public_path__ + "img/icon-tasks-white-old.13436a83.svg";